import { render, staticRenderFns } from "./DataTableColumn.vue?vue&type=template&id=9cbd8488&"
import script from "./DataTableColumn.vue?vue&type=script&lang=js&"
export * from "./DataTableColumn.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports